import { produce } from 'immer';
import { fetchOldShopFeedback, fetchOldShopFeedbackInit } from "@/services/api";
import { notification } from 'antd';

export default {
  namespace: 'feedback',

  state: {
    params: {},
    shopInfo: {},
    oldShopName: {
      value: ''
    },
    feedbackStatus: 0, // 0-未采集 1-已采集 2-放弃采集
  },

  effects: {
    *fetchOldShopFeedbackInit({ payload }, { call, put }) {
      const response = yield call(fetchOldShopFeedbackInit, payload);
      if (response.code === 200) {
        const data = response.data;
        yield put({
          type: 'updateFields',
          payload: {
            params: payload,
            feedbackStatus: data.status,
            shopInfo: {
              shopName: data.shopName,
              branchName: data.branchName,
              address: data.address
            }
          },
        });
      }
    },
    *fetchOldShopFeedback({ payload }, { call, put, select }) {
      const { params, oldShopName } = yield select(state => state.feedback);
      const response = yield call(fetchOldShopFeedback, {
        ...params,
        oldShopName: oldShopName.value,
        status: 1
      });
      if (response.code === 200) {
        yield put({
          type: 'updateFields',
          payload: {
            feedbackStatus: 1,
          },
        });
      } else {
        notification.error({
          message: response.msg,
          duration: 0,
        });
      }
    }
  },

  reducers: {
    updateFields(state, { payload }) {
      return produce(state, draft => {
        Object.keys(payload).forEach(key => {
          draft[key] = payload[key];
        })
      });
    }
  }
}
